import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useUserReducer = () =>
  useSelector((state: ApplicationState) => state.user);
